import { Button, Size, Spinner, Tier } from '@drawbotics/react-drylus';
import { useAppContext } from '@tokamakjs/react';
import {
  GoogleLoginResponse,
  GoogleLoginResponseOffline,
  useGoogleLogin,
} from 'react-google-login';

import { translate as t } from '~/utils';

import { AppContext } from '../../types';
import { AuthFlow } from '../MicrosoftSSO';
import { GoogleIcon } from './GoogleIcon';
import { useHandleGoogleErrors } from './use-handle-google-errors';

interface GoogleSSOProps {
  isLoading: boolean;
  flow: AuthFlow;
  onSuccess: (googleResponse: GoogleLoginResponse | GoogleLoginResponseOffline) => void;
  isInvitation?: boolean;
}

export const GoogleSSO = ({ isLoading, flow, isInvitation, onSuccess }: GoogleSSOProps) => {
  const appContext = useAppContext<AppContext>();

  const { showGoogleError } = useHandleGoogleErrors();
  const { signIn, loaded: isGoogleClientLoaded } = useGoogleLogin({
    clientId: appContext.env.GOOGLE_CLIENT_ID,
    onSuccess: onSuccess,
    onFailure: showGoogleError,
    cookiePolicy: 'single_host_origin',
    scope: 'profile email',
    accessType: 'offline',
    responseType: 'code',
    prompt: 'select_account',
  });

  const buttonText =
    flow === AuthFlow.SIGN_IN
      ? t('routes.login.sign_in_with_google')
      : isInvitation
      ? t('join_with_google')
      : t('routes.sign_up.sign_up_with_google');

  return (
    <Button
      disabled={!isGoogleClientLoaded || isLoading}
      leading={<GoogleIcon />}
      trailing={isLoading ? <Spinner /> : null}
      tier={Tier.SECONDARY}
      onClick={signIn}
      size={Size.LARGE}
      fullWidth>
      {buttonText}
    </Button>
  );
};
